// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	BackButton: 'back-button',
	SkipButton: 'skip-button',
	ContinueButton: 'continue-button',
	StepProgressNav: 'step-progress-nav',
} as const;
